import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styled, { keyframes } from "styled-components";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaArrowUp } from "react-icons/fa";
import { HomeHeader } from "../Home/HomeHeader";


export default function PrivacyPolicy() {
    const [content, setContent] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        fetch("/content/privacy-policy.md")
            .then((res) => res.text())
            .then((text) => {
                // remove the last © line from Markdown before rendering
                const cleaned = text
                    .split("\n")
                    .filter((line) => !/^©.*TeamCAST/i.test(line.trim()))
                    .join("\n")
                    .trim();

                setContent(cleaned);
            })
            .catch((err) => console.error("Failed to load privacy policy:", err));
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <>
            <HomeHeader text="Privacy Policy" link="/" />
            <PageWrapper>
                <ButtonWrapper>
                    <BackButton onClick={() => navigate("/")}>
                        <FaArrowLeft style={{ marginRight: "8px" }} />
                        Back to Home
                    </BackButton>
                </ButtonWrapper>
                <MarkdownContainer>
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
                </MarkdownContainer>

                <Footer>
                    <p>© 2025-2026 TeamCAST. All rights reserved.</p>
                    <FooterButtons>
                        <FooterButton onClick={scrollToTop}>
                            <FaArrowUp style={{ marginRight: "6px" }} />
                            Back to Top
                        </FooterButton>
                    </FooterButtons>
                    
                </Footer>
            </PageWrapper>
        </>
    );
}

/* ---------- Styled Components ---------- */

const PageWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
  font-family: system-ui, -apple-system, sans-serif;
  color: #1a1a1a;
  line-height: 1.7;
  text-align: left;
`;

const MarkdownContainer = styled.div`
  h1, h2, h3 {
    color: #003366; /* UCI blue accent */
    margin-top: 1.8rem;
  }

  p {
    margin: 1rem 0;
  }

  ul {
    padding-left: 1.5rem;
    list-style: disc;
  }

  a {
    color: #0066cc;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  em {
    color: #444;
  }
`;

const Footer = styled.footer`
  margin-top: 3rem;
  text-align: center;
  font-size: 0.9rem;
  color: #666;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 2rem;
`;

const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  background-color: #fafafc;
  color: #333333;
  border: 3px solid rgba(0, 0, 0, 0.04);
  padding: 8px 14px;
  border-radius: 11px;
  font-family: "SF Pro Text", system-ui, -apple-system, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.29;
  letter-spacing: -0.224px;
  cursor: pointer;
  transition: transform 0.1s ease-in-out;

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

const FooterButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin: 2rem 0;
`;

const FooterButton = styled.button`
  display: inline-flex;
  align-items: center;
  background-color: #f3f4f6;
  color: #374151;
  border: none;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s ease-in-out, box-shadow 0.2s;

  &:hover {
    background-color: #e5e7eb;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  }

  &:active {
    transform: scale(0.98);
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;
